import { render, staticRenderFns } from "./organisationPasswords.vue?vue&type=template&id=abdf7cee"
import script from "./organisationPasswords.vue?vue&type=script&lang=js"
export * from "./organisationPasswords.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports